import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { GzRuleConfigurationWebComponent } from './GzRuleConfigurationWebComponent';
import { GzRuleOutcomeWebComponent } from './GzRuleOutcomeWebComponent';

@customElement('gz-rule-settings')
export class GzRuleSettingsWebComponent extends LitElement {
  @property({ type: Object, attribute: false, reflect: false })
  rule: any = null;

  @property({ type: String, attribute: false, reflect: false })
  gridType;

  @property({ type: Boolean })
  isGZ = false;

  @property({ type: Array, attribute: false, reflect: false })
  tags;

  @property({ type: GzRuleConfigurationWebComponent, attribute: false, reflect: false })
  public ruleConfiguration: any = null;

  @property({ type: GzRuleOutcomeWebComponent, attribute: false, reflect: false })
  public ruleOutcome: any = null;

  @property({ type: Boolean, attribute: false, reflect: false })
  public isEdrStandalone: boolean;

  @property({ type: Boolean, attribute: false, reflect: false })
  public areAutomaticActionsAvailable: boolean;

  render() {
    return html`
      <div>
        <div class="d-flex flex-column">${this.renderRuleConfiguration()} ${this.renderRuleOutcome()}</div>
      </div>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('tagButtonInteract', this.handleTagEditable);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('tagButtonInteract', this.handleTagEditable);
  }

  private handleTagEditable(e) {
    const state = e.detail.addNewTagClicked;
    this.ruleConfiguration.addTagOpen = state;
    this.ruleOutcome.addTagOpen = state;
  }

  renderRuleConfiguration() {
    this.ruleConfiguration = new GzRuleConfigurationWebComponent();
    this.ruleConfiguration.tags = this.tags;
    this.ruleConfiguration.gridType = this.gridType;
    this.ruleConfiguration.rule = this.rule;
    return html`${this.ruleConfiguration}`;
  }

  renderRuleOutcome() {
    this.ruleOutcome = new GzRuleOutcomeWebComponent();
    this.ruleOutcome.gridType = this.gridType;
    this.ruleOutcome.isGZ = this.isGZ;
    this.ruleOutcome.rule = this.rule;
    this.ruleOutcome.isEdrStandalone = this.isEdrStandalone;
    this.ruleOutcome.areAutomaticActionsAvailable = this.areAutomaticActionsAvailable;
    return html`${this.ruleOutcome}`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-rule-settings': GzRuleSettingsWebComponent;
  }
}
